import { render, staticRenderFns } from "./ServiceChipGroup.vue?vue&type=template&id=fd0401e6&scoped=true&"
import script from "./ServiceChipGroup.vue?vue&type=script&lang=js&"
export * from "./ServiceChipGroup.vue?vue&type=script&lang=js&"
import style0 from "./ServiceChipGroup.vue?vue&type=style&index=0&id=fd0401e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0401e6",
  null
  
)

export default component.exports